export default __webpack_public_path__ + "static/userImg-731253c0fbbec1d3aa37669f649f7d88.png";